module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/2KWTk2TQNqCUKSsyquU0sQ-1ff1a897db16d715f4d06d2102271334.jpg";